

























import Vue from 'vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XButton from '@/components/atoms/Button/XButton.vue'

export default Vue.extend({
  name: 'QuantityInput',
  components: { XInput, XButton },
  data() {
    return {
      quantity: this.value,
      tryFetch: this.value,
    }
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  methods: {
    plus() {
      this.quantity = Number(this.quantity) + 1
    },
    minus() {
      this.quantity = Number(this.quantity) - 1
    },
  },
  watch: {
    value() {
      this.quantity = this.value
    },
    quantity() {
      this.quantity = Math.floor(Number(this.quantity))
      if (this.quantity <= 0) {
        this.quantity = 0
      } else if (this.quantity > 99) {
        this.quantity = 99
      }
      this.$emit('input', this.quantity)
    },
  },
})
